import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash, FaSave, FaTimes, FaPlus } from "react-icons/fa";
import AdminNavbar from "../Layout/AdminNavbar";
import API_BASE_URL from "../config";

export default function DesignationCRUD() {
  const [designations, setDesignations] = useState([]);
  const [newDesignation, setNewDesignation] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState("");
  const navigate = useNavigate();

  // Fetch all designations
  // const fetchDesignations = async () => {
  //   try {
  //     const res = await fetch(`${API_BASE_URL}/api/designations/all`);
  //     const data = await res.json();
  //     setDesignations(data);
  //   } catch (error) {
  //     toast.error("Failed to load designations");
  //   }
  // };

  const fetchDesignations = async () => {
  try {
    const token = sessionStorage.getItem("token");

    const res = await fetch(`${API_BASE_URL}/api/designations/all`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    if (!res.ok) {
      throw new Error("Failed to fetch");
    }

    const data = await res.json();
    setDesignations(data);

  } catch (error) {
    toast.error("Failed to load designations");
    console.error("Designation fetch error:", error);
  }
};


  useEffect(() => {
    fetchDesignations();
  }, []);

  // 🔐 Authentication check
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      toast.error("You must be logged in to access this page.");
      navigate("/");
    }
  }, [navigate]);

  // Add new designation
  const handleAdd = async () => {
  if (!newDesignation.trim()) {
    toast.warning("Please enter a designation name.");
    return;
  }

  try {
    const token = sessionStorage.getItem("token"); // ✅ FIX: define token here

    const res = await fetch(`${API_BASE_URL}/api/designations/add`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name: newDesignation }),
    });

    if (!res.ok) {
      throw new Error("Add failed");
    }

    toast.success("Designation added successfully!");
    setNewDesignation("");
    fetchDesignations(); // refresh list

  } catch (err) {
    toast.error("Failed to add designation.");
    console.error("Add error:", err);
  }
};


  // Update designation
  const handleUpdate = async (id) => {
  if (!editName.trim()) {
    toast.warning("Please enter a valid name.");
    return;
  }

  try {
    const token = sessionStorage.getItem("token"); // ✅ FIX: define token here

    const res = await fetch(`${API_BASE_URL}/api/designations/update/${id}`, {
      method: "PUT",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name: editName }),
    });

    if (!res.ok) {
      throw new Error("Update failed");
    }

    toast.success("Designation updated!");
    setEditingId(null);
    fetchDesignations();

  } catch (err) {
    toast.error("Failed to update designation.");
    console.error("Update error:", err);
  }
};

  // Delete designation
  // const handleDelete = async (id) => {
  //   if (!window.confirm("Delete this designation?")) return;
  //   await fetch(`${API_BASE_URL}/api/designations/delete/${id}`, {
  //     method: "DELETE",
  //   });
  //   toast.info("Designation deleted.");
  //   fetchDesignations();
  // };

  const handleDelete = async (id) => {
  if (!window.confirm("Delete this designation?")) return;

  try {
    const token = sessionStorage.getItem("token");

    const res = await fetch(`${API_BASE_URL}/api/designations/delete/${id}`, {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    if (!res.ok) {
      throw new Error("Delete failed");
    }

    toast.success("Designation deleted.");
    fetchDesignations(); // refresh list

  } catch (err) {
    toast.error("Failed to delete designation.");
    console.error("Delete error:", err);
  }
};


  return (
    <>
      {/* ✅ Fixed Navbar */}
      <div className="fixed-top">
        <AdminNavbar />
      </div>

      {/* ✅ Full page layout */}
      <div
        className="d-flex flex-column p-4"
        style={{
          minHeight: "100vh",
          backgroundColor: "#F5F7FB",
          marginTop: "110px",
        }}
      >
        <h3 className="fw-bold text-dark mb-4 text-start">
          Designation Management
        </h3>

        <div className="row flex-grow-1 g-4">
          {/* ✅ Left column - Add New Designation */}
          <div className="col-md-4 d-flex">
            <div
              className="card shadow-sm border-0 flex-fill"
              style={{
                borderRadius: "12px",
                height: "fit-content",
                alignSelf: "flex-start",
              }}
            >
              <div
                className="card-header fw-semibold"
                style={{
                  backgroundColor: "#DFE4EB",
                  color: "black",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                }}
              >
                Add New Designation
              </div>
              <div className="card-body">
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Enter designation name"
                  value={newDesignation}
                  onChange={(e) => setNewDesignation(e.target.value)}
                />
                <button
                  className="btn text-dark w-40"
                  style={{ backgroundColor: "#DFE4EB" }}
                  onClick={handleAdd}
                >
                  <FaPlus className="me-2" />
                  Add Designation
                </button>
              </div>
            </div>
          </div>

          {/* ✅ Right column - Designation List */}
          <div className="col-md-8 d-flex">
            <div
              className="card shadow-sm border-0 flex-fill"
              style={{ borderRadius: "12px" }}
            >
              <div
                className="card-header fw-semibold d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: "#DFE4EB",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                }}
              >
                <span>All Designations</span>
                <span className="badge bg-secondary">
                  {designations.length} Total
                </span>
              </div>

              <div
                className="card-body p-0"
                style={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                }}
              >
                <ul className="list-group list-group-flush">
                  {designations.length === 0 && (
                    <li className="list-group-item text-muted text-center py-3">
                      No designations found.
                    </li>
                  )}
                  {designations.map((d) => (
                    <li
                      key={d.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      {editingId === d.id ? (
                        <input
                          type="text"
                          className="form-control me-2"
                          value={editName}
                          onChange={(e) => setEditName(e.target.value)}
                          style={{ maxWidth: "300px" }}
                        />
                      ) : (
                        <span className="fw-medium">{d.name}</span>
                      )}

                      <div>
                        {editingId === d.id ? (
                          <>
                            <button
                              className="btn btn-success btn-sm me-2"
                              onClick={() => handleUpdate(d.id)}
                            >
                              <FaSave /> Save
                            </button>
                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={() => setEditingId(null)}
                            >
                              <FaTimes /> Cancel
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="btn  btn-sm me-2"
                              onClick={() => {
                                setEditingId(d.id);
                                setEditName(d.name);
                              }}
                            >
                              <FaEdit /> 
                            </button>
                            <button
                              className="btn  btn-sm"
                              onClick={() => handleDelete(d.id)}
                            >
                              <FaTrash /> 
                            </button>
                          </>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
